import {types} from '../../types';

const setGetDailyListAction = (payload) => {
    return {
        type: types.daily.SET_LIST,
        payload,
      }
}

const setGetDailyViewAction = (payload) => {
  return {
      type: types.daily.SET_VIEW,
      payload,
    }
}

const setGetLoginAction = (payload) => {
  return {
    type: types.daily.SET_LOGIN,
    payload
  }
}


export {
  setGetDailyListAction as SetGetDailyListAction,
  setGetDailyViewAction as SetGetDailyViewAction,
  setGetLoginAction as SetGetLoginAction
}